export default "* Et rart og trygt rum for fortællekredsen\n";